import { davinciTexts } from '@/assets/strings';
import HBBusManager from './hbBusManager';
import store from '../store/store';

export interface CampaignObject {
  partnerName: string;
  campaignName: string;
  campaignDescription: string;
  campaignImages: any;
  campaignSlug: string;
  subCategoryValue: string;
  campaignCategory: string;
  campaignCities: number[];
  campaignPrice: string;
  campaignDiscountedPrice: string;
  campaignEndDate: string;
}
const HBBusService = () => {
  // Register HBBusManager firstly.
  const { sendEventRequest } = HBBusManager();
  const pageLoad = (payload: any) =>
    sendEventRequest('mpc_partner_pageLoad', payload);
  const viewItem = (payload: any) =>
    sendEventRequest('mpc_partner_viewItem', payload);
  const clickItem = (payload: any) =>
    sendEventRequest('mpc_partner_clickItem', payload);

  return {
    pageLoadEvent: (page: string) =>
      pageLoad({
        page,
        merchantId: store.getState().auth.merchantId,
      }),

    campaignDetailPageLoad: (page: string, campaignObject: CampaignObject) =>
      pageLoad({
        page,
        merchantId: store.getState().auth.merchantId,
        ...campaignObject,
      }),

    appFormNextEvent: () =>
      clickItem({
        buttonType: 'forward',
        itemName: 'İleri',
        location: davinciTexts.appFormFirstStep,
        merchantId: store.getState().auth.merchantId,
      }),

    allCampaignsButtonEvent: () =>
      clickItem({
        buttonType: 'forward',
        itemName: 'Tüm Hizmetler',
        location: davinciTexts.home,
        merchantId: store.getState().auth.merchantId,
      }),

    bannerCountEvent: (
      keyword: string,
      bannerNames: string[],
      partnerNames: string[]
    ) =>
      viewItem({
        itemName: 'homepage-banner',
        keyword,
        location: davinciTexts.home,
        bannerNames,
        partnerNames,
      }),

    bannerChangeEvent: (
      oldIndex: number,
      activeIndex: number,
      direction: string
    ) =>
      clickItem({
        buttonType: direction,
        itemName: `homepage-banner-${oldIndex}/${activeIndex}`,
        location: davinciTexts.home,
        merchantId: store.getState().auth.merchantId,
      }),

    bannerClickEvent: (
      index: number,
      bannerName: string,
      bannerLink: string,
      bannerStartDate?: string,
      bannerEndDate?: string,
      partnerName?: string
    ) =>
      clickItem({
        buttonType: 'forward',
        itemName: `Banner-${index}`,
        location: davinciTexts.home,
        merchantId: store.getState().auth.merchantId,
        bannerName,
        bannerStartDate,
        bannerEndDate,
        bannerLink,
        partnerName,
      }),

    cityFilterEvent: () =>
      clickItem({
        buttonType: 'forward',
        itemName: 'city-filter',
        location: davinciTexts.campaigns,
        merchantId: store.getState().auth.merchantId,
      }),

    categoryFilterEvent: () =>
      clickItem({
        buttonType: 'forward',
        itemName: 'category-filter',
        location: davinciTexts.campaigns,
        merchantId: store.getState().auth.merchantId,
      }),

    searchFilterEvent: () =>
      clickItem({
        buttonType: 'forward',
        itemName: 'search-button',
        location: davinciTexts.campaigns,
        merchantId: store.getState().auth.merchantId,
      }),

    paginationChangeEvent: (
      oldIndex: string | number,
      activeIndex: string | number
    ) =>
      clickItem({
        buttonType: 'forward',
        itemName: 'pagination',
        location: davinciTexts.campaigns,
        message: {
          nextValue: activeIndex.toString(),
          previousValue: oldIndex.toString(),
          type: 'changePage',
        },
        merchantId: store.getState().auth.merchantId,
      }),

    paginationChangeEventCampaignRequest: (
      oldIndex: string | number,
      activeIndex: string | number
    ) =>
      clickItem({
        buttonType: 'forward',
        itemName: 'pagination',
        location: davinciTexts.campaignRequests,
        message: {
          nextValue: activeIndex.toString(),
          previousValue: oldIndex.toString(),
          type: 'changePage',
        },
        merchantId: store.getState().auth.merchantId,
      }),

    signupHeaderClickEvent: () =>
      clickItem({
        buttonType: 'forward',
        itemName: davinciTexts.bePartner,
        location: 'Header',
        merchantId: store.getState().auth.merchantId,
      }),
    academyHeaderClickEvent: () =>
      clickItem({
        buttonType: 'forward',
        itemName: davinciTexts.academy,
        location: 'Header',
        merchantId: store.getState().auth.merchantId,
      }),

    footerClickEvent: (eventDetail: any) => clickItem(eventDetail),

    campaignDetailOfferEvent: (
      itemName: string,
      campaignObject: CampaignObject
    ) =>
      clickItem({
        buttonType: 'forward',
        itemName,
        location: davinciTexts.campaignDetail,
        merchantId: store.getState().auth.merchantId,
        ...campaignObject,
      }),

    campaignGetPromocodeEvent: (
      promocode: string,
      campaignObject: CampaignObject
    ) =>
      clickItem({
        buttonType: 'forward',
        itemName: 'Kampanya kodu al',
        location: davinciTexts.campaignDetail,
        merchantId: store.getState().auth.merchantId,
        ...campaignObject,
        campaignCode: promocode,
      }),

    campaignDetailedInfoEvent: () =>
      clickItem({
        buttonType: 'forward',
        itemName: 'Detaylı Bilgi',
        location: davinciTexts.campaignDetail,
        merchantId: store.getState().auth.merchantId,
      }),

    rateCampaignVisible: (campaignObject: CampaignObject) =>
      viewItem({
        itemName: 'Hizmeti değerlendir',
        location: 'Hizmet Detay',
        merchantId: store.getState().auth.merchantId,
        ...campaignObject,
      }),

    rateCampaignButtonClick: (campaignObject: CampaignObject) =>
      clickItem({
        buttonType: 'forward',
        itemName: 'Hizmeti değerlendir',
        location: 'Hizmet Detay',
        merchantId: store.getState().auth.merchantId,
        ...campaignObject,
      }),
    rateCampaign: (
      campaignObject: CampaignObject,
      rate: string,
      review: string
    ) =>
      clickItem({
        buttonType: 'forward',
        itemName: 'Değerlendir',
        location: 'Hizmet Detay',
        merchantId: store.getState().auth.merchantId,
        ...campaignObject,
        rate: rate,
        review: review,
      }),
  };
};

export default HBBusService;
